module.exports = __webpack_public_path__ + "img/QidiSemiconductor.4b5b883c.jpg";